module.exports = __webpack_public_path__ + "static/media/FacistBoard_medium_4.690c94b0.png";